import {
  ACCOUNT_CREATION_DEFAULT_NOTES,
  ACCOUNT_CREATION_OPCITY_NOTES,
  ACCOUNT_CREATION_REDFIN_NOTES,
} from 'src/helpers/contextHelpers';
import { OPCITY, REDFIN } from 'src/helpers/partners';
import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { addPageLoader } from 'src/lib/flow/loaders';
import { your } from 'src/lib/flow/text';
import { updateAnswersCompleted } from 'src/store/apiUtils';

export function isEnabled() {
  return true;
}

const accountPage: FlowPage = {
  slug: () => 'account',
  isEnabled,
  autoAdvance: () => false,
  title: ({
    answers,
    featureFlags,
    inputContext: { partnerIdentifier, eligibleProducts, channel },
  }) => {
    // TODO: This is a no-op? The accountCreationTitle in the AccountPage component
    // is what is shown on the actual page
    const clientPossessive = your(answers, channel);
    const opendoorDirectEligible = eligibleProducts?.indexOf('opendoor_direct') !== -1;
    const exclusivesEligible = eligibleProducts?.indexOf('sell_with_exclusives') !== -1;
    if (partnerIdentifier === OPCITY.identifier) {
      return 'Where can Opendoor and our partner, realtor.com®, reach you?';
    } else if (partnerIdentifier === REDFIN.identifier) {
      return 'Where can Opendoor and our partner, Redfin, reach you?';
    } else if (!opendoorDirectEligible) {
      return `Where can we contact you with ${clientPossessive} selling options?`;
    } else if (exclusivesEligible) {
      return `Now, let's see how much your home could sell for`;
    } else if (featureFlags.isInListWithCertaintyTreatment) {
      return `Start selling with Opendoor`;
    }

    return `See ${clientPossessive} estimated offer right away`;
  },
  nextText: ({ inputContext: { partnerIdentifier, eligibleProducts } }) => {
    const opendoorDirectEligible = eligibleProducts?.includes('opendoor_direct');
    if (partnerIdentifier) {
      return 'Next';
    }
    if (eligibleProducts.length === 0) {
      return 'Submit & finish';
    }
    if (!opendoorDirectEligible) {
      return 'Next';
    }
    return 'Get my offer';
  },
  questions: (): Array<FlowQuestion> => {
    return [{ key: 'seller.account', type: 'element', component: 'account_form' }];
  },
  note: ({ inputContext: { partnerIdentifier } }) => {
    let notes = 'By continuing, ';
    if (partnerIdentifier === OPCITY.identifier) {
      notes += ACCOUNT_CREATION_OPCITY_NOTES;
    } else if (partnerIdentifier === REDFIN.identifier) {
      notes += ACCOUNT_CREATION_REDFIN_NOTES;
    } else {
      notes += ACCOUNT_CREATION_DEFAULT_NOTES;
    }
    return notes;
  },
  showPrivacyNotice: () => true,
  lastCarrot: () => true,
};

addPageLoader('account', 'account-sync-actions', async (listenerApi) => {
  const promises: Array<Promise<any>> = [];
  // wait for submit answers to complete
  promises.push(updateAnswersCompleted(listenerApi));

  // wait for our experiments and other calls to complete
  await Promise.all(promises);
});

export default accountPage;
